import { ChangeLevel } from '@enums/notifications';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InputSelectHelper } from '@helpers/input-select.helper';
import { LocalStorageManagerService } from '@services/data-managers/local-storage-manager.service';
import { Option } from 'rustic';
import { SocketService } from '@services/socket.service';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-notifications-filter-popup',
	templateUrl: './notifications-filter-popup.component.html',
	styleUrls: ['./notifications-filter-popup.component.less'],
	standalone: true,
	imports: [
		MatButtonToggleGroup,
		MatButtonToggle,
		MatFormField,
		MatLabel,
		MatSelect,
		FormsModule,
		MatOption,
		MatInput,
		MatButton,
		TranslateModule,
	],
})
export class NotificationsFilterPopupComponent {
	private readonly _ref = inject(MatDialogRef<NotificationsFilterPopupComponent>);
	private readonly _lsm = inject(LocalStorageManagerService);
	private readonly _ss = inject(SocketService);

	filters: { [key: string]: Option<string | string[] | ChangeLevel> } =
		this._lsm.filtersNotifications;
	intervals: { [key: string]: string | number }[] = InputSelectHelper.getIntervals();

	// eslint-disable-next-line @typescript-eslint/naming-convention
	ChangeLevel: typeof ChangeLevel = ChangeLevel;

	private _selectedInterval: number | null = this._lsm.intervalNotifications;

	onFilterClick(): void {
		this._ref.close();
	}

	setFilter(name: string, value: string | ChangeLevel): void {
		if (name === 'level' || name === 'endName') {
			const f = this.filters[name] as string[];
			const filterIndex = f.indexOf(value as string);

			if (value === null) {
				this.filters[name] = [];
			} else if (filterIndex !== -1) {
				f.splice(filterIndex, 1);
				this.filters[name] = f;
			} else {
				f.push(value as string);
				this.filters[name] = f;
			}
		} else {
			this.filters[name] = value as string;
		}

		this._lsm.filtersNotifications = this.filters;
	}

	isInFilterArray(filterName: string, value: string | ChangeLevel): boolean {
		return (this.filters[filterName] as string[]).some((f) => f === value);
	}

	get filtersAreClear(): boolean {
		return (
			(this.filters.endName as []).length === 0 &&
			(this.filters.level as []).length === 0 &&
			this.filters.change == null
		);
	}

	get selectedInterval(): number {
		return this._lsm.intervalNotifications;
	}

	set selectedInterval(interval: number) {
		if (this._selectedInterval === interval) {
			return;
		}

		this._selectedInterval = interval;
		this._lsm.intervalNotifications = interval;
		this._ss.reconnectWithInterval(interval);
	}

	get selectedCurrency(): string {
		return this.filters.currency as string;
	}

	set selectedCurrency(cn: string) {
		if (this.filters.currency !== cn) {
			this.filters.currency = cn;

			this._lsm.filtersNotifications = this.filters;
		}
	}
}
